import { apiClient } from '@/lib/api/api-client'
import { Patient, PatientItems } from '../types/patient'

export const patientApi = {
  getPatients: (params?: { hn?: string; cardId?: string; name?: string }) => {
    return apiClient.get<Patient[]>(`patients`, {
      params,
    })
  },

  getPatient: (id: string) => {
    return apiClient.get<Patient>(`patients/${id}`)
  },

  createPatient: (payload: any) => {
    return apiClient.post<Patient>(`patients`, payload)
  },

  updatePatient: (id: string, payload: any) => {
    return apiClient.put<Patient>(`patients/${id}`, payload)
  },

  deletePatient: (id: string) => {
    return apiClient.delete<void>(`patients/${id}`)
  },

  getPatientItems: (id: string) => {
    return apiClient.get<PatientItems>(`patients/${id}/items`)
  },
}
